import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OKRButton } from '../../Common/OKRButton';
import { AlertInfoIcon, DownloadIcon } from '../../../config/svg/CommonSvg';
import { AddIconBlue, AddIconSvg } from '../../../config/svg/CommonSvgIcon';
import '../../../styles/pages/okr-listing/okr-listing.scss';
import { RightArrowIcon } from '../../../config/svg/ArrowSvg';
import { useDispatch, useSelector } from 'react-redux';
import { defaultOkrDelete, publishObjective, refreshAdminDefaultOkrList } from '../../../action/adminDefaultOkr';
import { Enums } from '../../../config/enums';
import { AnimatedIcon } from '../../Common/AnimatedIcon';
import AddUserImg from '../../../images/copy-import-previous-goal.svg';
import { exportMyKpiReport, setShowKpiCreateOpen, updateKpiDescription } from '../../../action/MyKpis';
import { UserKpisKrList } from './UserKpisKrList';
import { clone } from 'lodash';
import { getUserDetails } from '../../../config/utils';
import { DefaultMyKpiFilter } from './DefaultKpiFilter';
import { useSnackbar } from 'notistack';
import noRecordFound from '../../../images/search-placeholder.svg';

export const UserKpisList: React.FC<any> = (props: any) => {
	const {
		listLoading,
		isAllowToSendApproval,
		showApiMsg,
		cycleId,
		selectedCycleDetails,
		highlightDefaultOkr,
		setShowLoader,
		showLoader,
		defaultOkrAPICall,
		listingData,
		setListingData,
		getEmployeeId,
		defaultSearchFilter,
		finalFilterCondition,
		setFinalFilterCondition,
		appliedFilter,
		setAppliedFilter,
		getKpiUser,
		handleExpandKeyResult,
		expandedKrList,
		setExpandedKrList,
		kpiDataList,
	} = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { refreshDefaultOkr } = useSelector((state: any) => state.adminDefaultOkrReducer);
	const [dataBeforeEdit, setDataBeforeEdit] = useState<any>();
	const [alertMessage, setAlertMessage] = useState<any>('');
	const [publishDisabled, setPublishDisabled] = useState(false);

	useEffect(() => {
		if (refreshDefaultOkr) {
			dispatch(refreshAdminDefaultOkrList(false));
			defaultOkrAPICall();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshDefaultOkr]);

	const handlePublishOkr = async () => {
		setPublishDisabled(true);
		const response: any = await dispatch(
			publishObjective({
				objectiveCycleId: selectedCycleDetails?.organisationCycleId,
				objectiveId: 0,
				loginUserId: 0,
			})
		);
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			dispatch(refreshAdminDefaultOkrList(true));
			setPublishDisabled(false);
		} else {
		}
	};
	const handleExpandAll = () => {
		let defaultListing: any[] = [];
		listingData.forEach((okrKey: any) => {
			defaultListing.push(okrKey.goalObjectiveId);
		});
		setExpandedKrList(defaultListing);
	};
	const handleCollapseAll = () => {
		setExpandedKrList([]);
	};

	const deleteDefaultOkr = async (okrDetails: any) => {
		try {
			if (okrDetails?.goalObjectiveId) {
				setShowLoader(true);
				const isGoalObjective = true;
				const requestParams = `id=${okrDetails?.goalObjectiveId}&isGoalObjective=${isGoalObjective}`;
				const response: any = await dispatch(defaultOkrDelete(requestParams));
				if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
					defaultOkrAPICall(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : null;
					const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
					showApiMsg('error', messages || 'Error occurred while fetching default okr details');
					setShowLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleListAction = (e: any, goal: any, keyData: any, type: any, isEdit = true) => {
		const updatedList = listingData.map((item: any) => {
			if (item.goalObjectiveId === goal.goalObjectiveId) {
				item.edit = false;
				item.myGoalsDetails = item.myGoalsDetails.map((keys: any) => {
					keys.edit = false;
					keys.expand = false;
					if (keys.goalKeyId === keyData.goalKeyId) {
						setDataBeforeEdit(clone(keyData));
						keys.edit = isEdit;
						keys.expand = isEdit;
					}
					return keys;
				});
			}
			return item;
		});
		setListingData(updatedList);
	};

	const updateTextValue = (e: any, data: any, type: number, keyData: any, value: string) => {
		let updatedList = [];

		if (type === 3) {
			updatedList = listingData.map((item: any) => {
				if (item.goalObjectiveId === data.goalKeyId) {
					item.keyDescription = value;
					item.edit = false;
				}
				return item;
			});
		} else if (type === 2) {
			updatedList = listingData.map((item: any) => {
				if (item.goalObjectiveId === data.goalObjectiveId) {
					item.myGoalsDetails = item.myGoalsDetails.map((keys: any) => {
						if (keys.goalKeyId === keyData.goalKeyId) {
							keys.keyDescription = value;
							keys.edit = false;
						}
						return keys;
					});
				}
				return item;
			});
		} else if (type === 1) {
			// data.objectiveName = value;
			updatedList = listingData.map((item: any) => {
				if (item.goalObjectiveId === data.goalObjectiveId) {
					item.objectiveName = value;
				}
				return item;
			});
		}

		setListingData(updatedList);
	};

	const [showEditLoader, setShowEditLoader] = useState<any>({ status: '', id: 0 });
	const updateName = async (e: any, okr: any, goalType: any, keyData: any, textValue: any) => {
		let requestParam: any = {
			kpiDescription: textValue,
			goalKeyId: keyData.goalKeyId,
			keyResultId: keyData.goalKeyId,
		};
		let reqUri = `kpiDescription=${textValue}&goalKeyId=${keyData.goalKeyId}&keyResultId=${keyData.goalKeyId}`;
		const response: any = await dispatch(updateKpiDescription(reqUri, requestParam));
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			updateTextValue(e, okr, goalType, keyData, textValue);
			setShowEditLoader({ status: '', id: 0 });
			showApiMsgs(response?.data?.messageList.Result, 'success');
		}
	};
	const userDetail: any = getUserDetails();

	const handleExportMyKpiReport = async () => {
		try {
			let userId =
				props.currentUser && props.currentUser.employeeId ? props.currentUser.employeeId : userDetail?.employeeId;
			let requestParam = `cycleId=${cycleId}&employeeId=${userId}`;
			const response: any = await dispatch(exportMyKpiReport(requestParam));
			if (response) {
				const defaultName = 'myKpiReport.xlsx';
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
				const matches = filenameRegex.exec(response.headers['content-disposition']);
				link.setAttribute('download', matches && matches.length > 0 ? matches[1] : defaultName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
			// setListLoading(false);
		} catch (error) {
			console.error(error);
		}
	};
	const { enqueueSnackbar } = useSnackbar();
	const showApiMsgs = (msg: string, variant: any) => {
		enqueueSnackbar(msg, {
			variant: variant,
			autoHideDuration: 5000,
		});
	};
	const isFilterApplied = () => {
		return (
			finalFilterCondition &&
			(finalFilterCondition?.status.length > 0 || finalFilterCondition?.kpiCategoryMasterId.length > 0)
		);
	};
	return (
		<>
			{(!listLoading && listingData.length > 0) || isFilterApplied() ? (
				<Box className='okr-listing-head'>
					<Box className='okr-listing-head-left'>
						{listingData.length ? (
							<Box className='expand-all'>
								{expandedKrList.length === listingData.length ? (
									<OKRButton
										className='expand-all-inner collapse-active'
										title={
											<Typography variant='body2' className='expand-txt'>
												{t('collapseAllLabel')}
											</Typography>
										}
										text={<RightArrowIcon />}
										handleClick={(e) => handleCollapseAll()}
									/>
								) : (
									<OKRButton
										className='expand-all-inner'
										title={
											<Typography variant='body2' className='expand-txt'>
												{t('expendAllLabel')}
											</Typography>
										}
										text={<RightArrowIcon />}
										handleClick={(e) => handleExpandAll()}
									/>
								)}
								<Typography className='sort-obj-title' variant='h2'>
									{t('keyPerformanceIndicators')}
								</Typography>
							</Box>
						) : (
							<></>
						)}

						{alertMessage && (
							<Box className='default-okrs-info-mssg'>
								<AlertInfoIcon />
								<Typography variant='body2'>{alertMessage}</Typography>
							</Box>
						)}
					</Box>
					<Box className='okr-listing-head-right'>
						<DefaultMyKpiFilter
							showChip={true}
							appliedFilter={appliedFilter}
							setAppliedFilter={setAppliedFilter}
							setFinalFilterCondition={setFinalFilterCondition}
							finalFilterCondition={finalFilterCondition}
							defaultSearchFilter={defaultSearchFilter}
						/>
						{listingData.length ? (
							<OKRButton
								handleClick={handleExportMyKpiReport}
								className='btn-circle-white download-btn'
								icon={<DownloadIcon />}
								title={t('downloadKPI')}
							/>
						) : (
							<></>
						)}
						{!kpiDataList.isLocked && (
							<Tooltip title={`${t('createKpi')}`} arrow>
								<OKRButton
									className={'add-btn'}
									color='primary'
									handleClick={() => {
										dispatch(setShowKpiCreateOpen(true));
									}}
									id='create-okr-btn'
									icon={<AddIconSvg />}
								/>
							</Tooltip>
						)}
					</Box>
				</Box>
			) : (
				<></>
			)}

			{listLoading ? (
				<Box className='loading-center'>
					<Typography>{t('loading')}</Typography>
				</Box>
			) : listingData.length === 0 ? (
				isFilterApplied() ? (
					<Box className='no-records-area no-kpis-area'>
						<Box className='no-record-message'>
							<Typography variant='h2' component='h2'>
								{t('noKpisFound')}
							</Typography>
							<img width='440' alt={t('globalSearchNoRecord')} src={noRecordFound} />
						</Box>
					</Box>
				) : selectedCycleDetails?.cycleStatus !== 1 ? (
					<Box className='no-records-area no-kpis-area'>
						<Box className='no-record-message'>
							<Typography variant='h2' component='h2'>
								{t('createKpis')}
							</Typography>
							<Box className='get-started-card'>
								<AnimatedIcon
									className='add-user-img'
									width='157'
									type='image/svg+xml'
									alt='No user'
									imagePath={AddUserImg}
								/>

								<Box>
									<Box className='get-started-card-content'>
										<Typography>{t('createDefaultKpisCard')}</Typography>
									</Box>
									<Box className='get-started-card-link'>
										<Link
											onClick={() => {
												dispatch(setShowKpiCreateOpen(true));
											}}
										>
											<AddIconBlue />
											{t('letsCreatetxt')}
										</Link>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				) : (
					<Box className='no-records-area'>
						<Box className='no-record-message'>
							<Typography variant='h2' component='h2'>
								{t('createKpis')}
							</Typography>
							<Box className='get-started-card'>
								<AnimatedIcon
									className='add-user-img'
									width='157'
									type='image/svg+xml'
									alt='No user'
									imagePath={AddUserImg}
								/>

								<Box>
									<Box className='get-started-card-content'>
										<Typography>{t('createDefaultKpisCard')}</Typography>
									</Box>
									<Box className='get-started-card-link'>
										<Link
											onClick={() => {
												dispatch(setShowKpiCreateOpen(true));
											}}
										>
											<AddIconBlue />
											{t('letsCreatetxt')}
										</Link>
									</Box>
								</Box>
							</Box>
						</Box>
					</Box>
				)
			) : (
				<Box className='my-obj-listing my-kpi-listing'>
					{listingData.map((objData: any) => (
						<UserKpisKrList
							showApiMsg={showApiMsg}
							selectedCycleDetails={selectedCycleDetails}
							highlightDefaultOkr={highlightDefaultOkr}
							setShowLoader={setShowLoader}
							showLoader={showLoader}
							defaultOkrAPICall={defaultOkrAPICall}
							listingData={listingData}
							setListingData={setListingData}
							objData={objData}
							handleExpandKeyResult={handleExpandKeyResult}
							expandedKrList={expandedKrList}
							handleListAction={handleListAction}
							setExpandedKrList={setExpandedKrList}
							getEmployeeId={getEmployeeId}
							updateName={updateName}
							getKpiUser={getKpiUser}
							isAllowToSendApproval={isAllowToSendApproval}
							kpiDataList={kpiDataList}
						/>
					))}
				</Box>
			)}
		</>
	);
};
